var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErroCirle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 0.333328C3.31325 0.333328 0.333252 3.31333 0.333252 7C0.333252 10.6867 3.31325 13.6667 6.99992 13.6667C10.6866 13.6667 13.6666 10.6867 13.6666 7C13.6666 3.31333 10.6866 0.333328 6.99992 0.333328ZM10.3333 9.39333L9.39325 10.3333L6.99992 7.93999L4.60659 10.3333L3.66659 9.39333L6.05992 7L3.66659 4.60666L4.60659 3.66666L6.99992 6.06L9.39325 3.66666L10.3333 4.60666L7.93992 7L10.3333 9.39333Z",
    fill: "#D32F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErroCirle);
export default __webpack_public_path__ + "static/media/erro-cirle.41fa6fcfae2d43edd5792a880d5861d9.svg";
export { ForwardRef as ReactComponent };